import { buildSharePageUrl } from '@/utils/SharePageUrl'

const buyerWebOrigin =
  (process.env.REACT_APP_BUYER_WEB_ORIGIN ?? 'https://www.yuanling.com').replace(
    /\/+$/,
    ''
  )

const buyerSharePageConfigs = new Map<string, string>([
  [
    'sharePageDomain',
    JSON.stringify({ shareH5BaseLink: `${buyerWebOrigin}/` }),
  ],
])

/** 登录勾选协议（与 buyer-web Footer 对应项一致，不含交易规则） */
export const LoginAgreementLinks = [
  {
    label: '用户协议',
    href: buildSharePageUrl(buyerSharePageConfigs, 'user-agreement'),
  },
  {
    label: '隐私协议',
    href: buildSharePageUrl(buyerSharePageConfigs, 'policy-statement'),
  },
  {
    label: '个人信息保护协议',
    href: buildSharePageUrl(buyerSharePageConfigs, 'personal-information-protect'),
  },
] as const
